/**
 * Interface for progress bar component
 */
export interface ProgressBar {
  id?: string;
  color?: string;
  label: string;
  value: number;
  labelLeft?: string;
  labelRight?: string;
  labelTopRight?: string;
  note?: string;
  showNote?: boolean;
  used?: string;
  remaining?: string;
  total?: string;
}

export interface ProgressBarArgs {
  data: ProgressBar;
}
